<template>
  <div class="CommandUserList">
    <ul class="cardWrap">
      <li v-for="(v,i) in areaList"
        :key="i"
        @click="userActive =i,changeData()"
        :class="{activeLi:i == userActive}">
        {{v.name}}
      </li>
    </ul>
    <div class="cardContent">
      <p style="color:#39E4EA"><i class="iconfont icon-yonghu"></i>{{areaList[userActive].user}} <i class="iconfont icon-dianhua"
          style="margin-left:10px"></i>{{areaList[userActive].phone}}</p>
      <p><i class="iconfont icon-dizhi"></i>{{areaList[userActive].address}}</p>
    </div>
    <ul class="listWrap">
      <li>街镇名称</li>
      <li>运营人员</li>
      <li>联系电话</li>
      <li>值班电话</li>
    </ul>
    <vue-seamless-scroll :data="tableList"
      :class-option="options"
      class="scrollBox">
      <ul v-for="(v, i) in tableList"
        :key="i">
        <li>{{ v.name }}</li>
        <li>{{ v.user }}</li>
        <li>{{ v.phone }}</li>
        <li>{{ v.landline }}</li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
export default {
  data() {
    return {
      areaList: [
        {
          name: "东坡区",
          user: "赵六",
          phone: "139****8240",
          address: "东坡区运营中心",
        },
        {
          name: "彭山区",
          user: "张倩",
          phone: "139****2400",
          address: "彭山区运营中心",
        },
        {
          name: "青神县",
          user: "卓平",
          phone: "139****8240",
          address: "青神县运营中心",
        },
        {
          name: "单棱县 ",
          user: "李明",
          phone: "139****8240",
          address: "单棱县运营中心",
        },
        {
          name: "仁寿县",
          user: "赵六",
          phone: "139****8240",
          address: "仁寿县运营中心",
        },
        {
          name: "洪雅县",
          user: "田秀芳",
          phone: "137****8410",
          address: "洪雅县运营中心",
        },
      ],
      userActive: 0,
      tableList: [
        {
          name: "通惠街道",
          user: "刘赋",
          phone: "138****4510",
          landline: "028-87706811",
        },
        {
          name: "大石桥街道",
          user: "卓平",
          phone: "139****4500",
          landline: "028-87706544",
        },
        {
          name: "苏祠街道",
          user: "李思意",
          phone: "139****8240",
          landline: "028-87454121",
        },
        {
          name: "太和镇",
          user: "谢翠品",
          phone: "138****8541",
          landline: "028-86691803",
        },
        {
          name: "永寿镇",
          user: "李明",
          phone: "139****8584",
          landline: "028-86542141",
        },
        {
          name: "多悦镇",
          user: "曾有才",
          phone: "139****8541",
          landline: "028-86587412",
        },
        {
          name: "万盛镇",
          user: "鞠暄妍",
          phone: "138****8714",
          landline: "028-88744121",
        },
        {
          name: "修文镇",
          user: "田秀芳",
          phone: "137****8410",
          landline: "028-88745121",
        },
        {
          name: "松江镇",
          user: "张倩",
          phone: "139****2400",
          landline: "028-85774112",
        },
        {
          name: "崇礼镇",
          user: "禹叶彤",
          phone: "132****3440",
          landline: "028-61350608",
        },
        {
          name: "苏祠街道",
          user: "廉盼晴",
          phone: "132****3440",
          landline: "028-87706382",
        },
        {
          name: "崇礼镇",
          user: "禹叶彤",
          phone: "132****3897",
          landline: "028-61350608",
        },
        {
          name: "永寿镇",
          user: "李明",
          phone: "139****8584",
          landline: "028-86542141",
        },
        {
          name: "多悦镇",
          user: "曾有才",
          phone: "139****8541",
          landline: "028-86587412",
        },
        {
          name: "万盛镇",
          user: "鞠暄妍",
          phone: "138****8714",
          landline: "028-88744121",
        },
      ],
    };
  },
  computed: {
    options() {
      return {
        singleHeight: 32,
        step: 0.3,
        limitMoveNum: this.tableList.length,
        waitTime: 100,
      };
    },
  },
  methods: {
    changeActive() {},
    changeData() {
      function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
      }
      shuffle(this.tableList);
    },
  },
};
</script>

<style lang="scss" scoped>
.CommandUserList {
  width: 90%;
  height: calc(100% - 280px);
  margin: 0 auto;
  .cardWrap {
    width: 100%;
    height: 45px;
    border-bottom: 1px solid #2d4876;
    @include setFlexBetween;
    li {
      width: 16%;
      height: 100%;
      color: #b5bece;
      @include setFlexCenter;
      cursor: pointer;
    }
    .activeLi {
      color: #ffffff;
      background: url("~@/assets/images/msgt/userActive.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .cardContent {
    width: 100%;
    height: 80px;
    background: linear-gradient(60deg, #083464 0%, rgba(31, 41, 58, 0.15) 100%);
    border-radius: 1px;
    color: #e1e9f7;
    @include setFlexColumn;
    justify-content: center;
    p {
      margin-left: 20px;
      font-size: 15px;
      i {
        margin-right: 5px;
      }
    }
    p:first-child {
      margin-bottom: 10px;
    }
  }
  .listWrap {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: url("~@/assets/images/msgt/userHead.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    @include setFlexBetween;
    li {
      width: 25%;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #fff;
    }
  }
  .scrollBox {
    width: 100%;
    height: calc(100% - 180px);
    overflow: hidden;
    ul {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: #8ba3ab;
      @include setFlexBetween;
      li {
        width: 25%;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #e1e9f7;
      }
    }
    ul:nth-child(odd) {
      background: rgba(10, 29, 62, 1);
    }
    ul:nth-child(even) {
      background: rgba(42, 61, 92, 0.6);
    }
  }
}
</style>